<template>
  <div class="loader"></div>
</template>
<script>
export default {
  name: "loader",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.loader {
  margin: 5px;
  border: 2px solid #f3f3f3;
  border-radius: 50%;
  border-top: 2px solid #4558dd;
  width: 15px;
  height: 15px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Templates/loader.vue